import React, { lazy } from "react";
import Loadable from "../../components/Loadable";
import config from "./config";
const List = Loadable(lazy(() => import("./AbmComponents/List")));
const Update = Loadable(lazy(() => import("./AbmComponents/Update")));
const Show = Loadable(lazy(() => import("./AbmComponents/Show")));
const Create = Loadable(lazy(() => import("./AbmComponents/Create")));

const routes = [
  {
    path: "colores",
    element: <List config={config} />,
  },
  {
    path: "colores/update/:id",
    element: <Update />,
  },
  {
    path: "colores/create",
    element: <Create />,
  },
  {
    path: "colores/show/:id",
    element: <Show />,
  },
];
export default routes;
